import React, { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import SaveIcon from '@mui/icons-material/Save';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Box,
  Divider,
  Paper,
  InputAdornment,
  IconButton,
   Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const Cochlear = () => {
  const [formData, setFormData] = useState({
    demographic: {
      serialNo: '',
      name: '',
      caseNumber: '',
      dob: '',
      age: '',
      gender: '',
      parents: {
        father: { name: '', education: '', occupation: '' },
        mother: { name: '', education: '', occupation: '' },
        guardian: { name: '', education: '' },
      },
      education: '',
      occupation: '',
      address: '',
      phoneNo: '',
      familyIncome: '',
      ageOfOnset: '',
      comorbidities: '',
      hearingAid: {
        type: '',
        duration: { days: '', months: '', years: '' },
        usage: '',
        hours: '',
      },
      provisionalDiagnosis: '',
      documents: {
        aadhar: false,
        incomeCaste: false,
        birthCertificate: false,
        disabilityCertificate: false,
        entClearance: false,
        speechEvaluation: false,
      },
    },
    intraOp: {
      opNumber: '',
      scheme: '',
      ciCompany: '',
      sideOfImplant: '',
      modelOfImplant: '',
      speechProcessorModel: '',
      surgeryDate: '',
      surgeonName: '',
      surgeryCenter: '',
      surgeryType: '',
      intraOpTest: {
        boxTest: { status: '', noOfElectrodes: '', specifyElectrodes: '' },
        impedance: '',
        cArmResults: '',
        art: '',
        nrt: '',
        cochlear: { status: '', noOfElectrodes: '', specifyElectrodes: '' },
        medEl: { status: '', noOfElectrodes: '', specifyElectrodes: '' },
        digisonic: { status: '', noOfElectrodes: '', specifyElectrodes: '' },
        ab: { status: '', noOfElectrodes: '', specifyElectrodes: '' },
        electrodesInside: '',
        electrodesOutside: '',
        electrodeNumbers: '',
        reportFiles: {
          impedanceNRT: null,
          iftART: null,
          impedanceMeasure: null,
          intraOpFindings: null,
        },
      },
      advancedMeasure: '',
      measurementReport: '',
    },
    switchOn: {
      opEnter: '',
      switchOnCenter: '',
      dateOfSwitchOn: '',
      surgeonName: '',
      surgeryCenter: '',
      audiologistName: '',
      referralLetter: '',
      modelOfImplantWithSNo: '',
      modelOfSpeechProcessorWithSNo: '',
      earImplanted: '',
      mapping: {
        type: '',
        nrt: false,
        esrt: false,
        ecap: false,
      },
      documents: {
        kitCounselling: null,
        dischargeSummary: null,
        postOpXray: null,
        others: null,
      },
      remarks: '',
      mappingAppointments: [],
      selectedAppointment: '',
    },
  });
  const [searchOpNumber, setSearchOpNumber] = useState('');
  const [searchResult, setSearchResult] = useState(null);
   const [loading, setLoading] = useState(false);
    const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
    const [openPasswordModal, setOpenPasswordModal] = useState(false);
    const [password, setPassword] = useState('');
    const [downloadFormat, setDownloadFormat] = useState('excel');

  const handleDemographicChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      demographic: {
        ...prev.demographic,
        [name]: value,
      },
    }));
  };

  const handleIntraOpChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      intraOp: {
        ...prev.intraOp,
        [name]: value,
      },
    }));
  };

  const handleSwitchOnChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      switchOn: {
        ...prev.switchOn,
        [name]: value,
      },
    }));
  };

  const handleNestedChange = (section, field, subField, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: {
          ...prev[section][field],
          [subField]: value,
        },
      },
    }));
  };

  const handleTestChange = (testType, subField, value) => {
    setFormData((prev) => ({
      ...prev,
      intraOp: {
        ...prev.intraOp,
        intraOpTest: {
          ...prev.intraOp.intraOpTest,
          [testType]: {
            ...prev.intraOp.intraOpTest[testType],
            [subField]: value,
          },
        },
      },
    }));
  };

  const handleFileChange = (section, fileType, file) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        reportFiles: section === 'intraOp'
          ? {
              ...prev[section].intraOpTest.reportFiles,
              [fileType]: file,
            }
          : {
              ...prev[section].documents,
              [fileType]: file,
            },
      },
    }));
  };

  const handleAppointmentChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      switchOn: {
        ...prev.switchOn,
        selectedAppointment: value,
        mappingAppointments: prev.switchOn.mappingAppointments.includes(value)
          ? prev.switchOn.mappingAppointments
          : [...prev.switchOn.mappingAppointments, value],
      },
    }));
  };

  const handleAppointmentEdit = (index, value) => {
    setFormData((prev) => {
      const updatedAppointments = [...prev.switchOn.mappingAppointments];
      updatedAppointments[index] = value;
      return {
        ...prev,
        switchOn: {
          ...prev.switchOn,
          mappingAppointments: updatedAppointments,
        },
      };
    });
  };


    const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Case History Child ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "child_case_history",
          formName: "Child_Case_History",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Child_Case_History _${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};


  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };
  const handleSearch = () => {
    if (searchOpNumber === formData.intraOp.opNumber) {
      setSearchResult(formData.demographic);
    } else {
      setSearchResult(null);
      alert('No matching OP Number found.');
    }
  };

  const handleSubmit = () => {
    console.log('Form Data:', formData);
    // Add your save logic here (e.g., API call)
  };

  const appointmentOptions = [
    '1 week post switch-on',
    '1 month post switch-on',
    '2 months post switch-on',
    '3 months post switch-on',
    '6 months post switch-on',
    '1 year post switch-on',
    '2 years post switch-on',
  ];
 
  return (
    <Box sx={{ p: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          {/* Download Button - Top Right */}
      <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<DownloadIcon />}
          onClick={handleDownloadClick}
          disabled={loading}
          sx={{ 
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
              transition: 'all 0.3s ease'
            }
          }}
        >
          Download 
        </Button>
      </Box>
      <Grid container spacing={3}>
        {/* Demographic Card */}
        <Grid item xs={12} md={6}>
          <Card elevation={3} sx={{ borderRadius: 2, height: '100%' }}>
            <CardContent>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                Demographic Details
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Serial No"
                    name="serialNo"
                    value={formData.demographic.serialNo}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Name"
                    name="name"
                    value={formData.demographic.name}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Case Number"
                    name="caseNumber"
                    value={formData.demographic.caseNumber}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="DOB"
                    type="date"
                    name="dob"
                    value={formData.demographic.dob}
                    onChange={handleDemographicChange}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Age"
                    name="age"
                    value={formData.demographic.age}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel>Gender</InputLabel>
                    <Select
                      name="gender"
                      value={formData.demographic.gender}
                      onChange={handleDemographicChange}
                      label="Gender"
                    >
                      <MenuItem value="Male">Male</MenuItem>
                      <MenuItem value="Female">Female</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 'medium' }}>
                    Parents Details
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                </Grid>
                <Grid container spacing={2} sx={{ pl: 2 }}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                      Father
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Name"
                      value={formData.demographic.parents.father.name}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'parents', 'father', {
                          ...formData.demographic.parents.father,
                          name: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Education"
                      value={formData.demographic.parents.father.education}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'parents', 'father', {
                          ...formData.demographic.parents.father,
                          education: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Occupation"
                      value={formData.demographic.parents.father.occupation}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'parents', 'father', {
                          ...formData.demographic.parents.father,
                          occupation: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                      Mother
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Name"
                      value={formData.demographic.parents.mother.name}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'parents', 'mother', {
                          ...formData.demographic.parents.mother,
                          name: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Education"
                      value={formData.demographic.parents.mother.education}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'parents', 'mother', {
                          ...formData.demographic.parents.mother,
                          education: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Occupation"
                      value={formData.demographic.parents.mother.occupation}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'parents', 'mother', {
                          ...formData.demographic.parents.mother,
                          occupation: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                      Guardian
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Name"
                      value={formData.demographic.parents.guardian.name}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'parents', 'guardian', {
                          ...formData.demographic.parents.guardian,
                          name: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Education"
                      value={formData.demographic.parents.guardian.education}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'parents', 'guardian', {
                          ...formData.demographic.parents.guardian,
                          education: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Education"
                    name="education"
                    value={formData.demographic.education}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Occupation"
                    name="occupation"
                    value={formData.demographic.occupation}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Address"
                    name="address"
                    value={formData.demographic.address}
                    onChange={handleDemographicChange}
                    multiline
                    rows={3}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Phone No"
                    name="phoneNo"
                    value={formData.demographic.phoneNo}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel>Family Income</InputLabel>
                    <Select
                      name="familyIncome"
                      value={formData.demographic.familyIncome}
                      onChange={handleDemographicChange}
                      label="Family Income"
                    >
                      <MenuItem value="Low">Low</MenuItem>
                      <MenuItem value="Mid">Mid</MenuItem>
                      <MenuItem value="High">High</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Age of Onset"
                    name="ageOfOnset"
                    value={formData.demographic.ageOfOnset}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Comorbidities"
                    name="comorbidities"
                    value={formData.demographic.comorbidities}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 'medium' }}>
                    Hearing Aid Details
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                </Grid>
                <Grid container spacing={2} sx={{ pl: 2 }}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Type of Hearing Aid"
                      value={formData.demographic.hearingAid.type}
                      onChange={(e) => handleNestedChange('demographic', 'hearingAid', 'type', e.target.value)}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                      Duration
                    </Typography>
                  </Grid>
                  <Grid item xs={4} sm={2}>
                    <TextField
                      fullWidth
                      label="Days"
                      value={formData.demographic.hearingAid.duration.days}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'hearingAid', 'duration', {
                          ...formData.demographic.hearingAid.duration,
                          days: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={4} sm={2}>
                    <TextField
                      fullWidth
                      label="Months"
                      value={formData.demographic.hearingAid.duration.months}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'hearingAid', 'duration', {
                          ...formData.demographic.hearingAid.duration,
                          months: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={4} sm={2}>
                    <TextField
                      fullWidth
                      label="Years"
                      value={formData.demographic.hearingAid.duration.years}
                      onChange={(e) =>
                        handleNestedChange('demographic', 'hearingAid', 'duration', {
                          ...formData.demographic.hearingAid.duration,
                          years: e.target.value,
                        })
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Usage</InputLabel>
                      <Select
                        value={formData.demographic.hearingAid.usage}
                        onChange={(e) => handleNestedChange('demographic', 'hearingAid', 'usage', e.target.value)}
                        label="Usage"
                      >
                        <MenuItem value="Full time">Full time</MenuItem>
                        <MenuItem value="Part time">Part time</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Hours of Usage"
                      value={formData.demographic.hearingAid.hours}
                      onChange={(e) => handleNestedChange('demographic', 'hearingAid', 'hours', e.target.value)}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Provisional Diagnosis"
                    name="provisionalDiagnosis"
                    value={formData.demographic.provisionalDiagnosis}
                    onChange={handleDemographicChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Right Column - Contains both Intra-Op and Switch-On */}
        <Grid item xs={12} md={6}>
          <Grid container direction="column" spacing={3}>
            {/* Intra-Op Card */}
            <Grid item>
              <Card elevation={3} sx={{ borderRadius: 2 }}>
                <CardContent>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                    Intra-Op Details
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Search OP Number"
                        value={searchOpNumber}
                        onChange={(e) => setSearchOpNumber(e.target.value)}
                        variant="outlined"
                        size="small"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={handleSearch}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    {searchResult && (
                      <Grid item xs={12}>
                        <Paper elevation={1} sx={{ p: 2, mb: 2, bgcolor: '#e3f2fd' }}>
                          <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
                            Demographic Data
                          </Typography>
                          <Typography>Name: {searchResult.name}</Typography>
                          <Typography>Case Number: {searchResult.caseNumber}</Typography>
                          <Typography>Age: {searchResult.age}</Typography>
                          <Typography>Gender: {searchResult.gender}</Typography>
                          <Typography>DOB: {searchResult.dob}</Typography>
                          <Typography>Father's Name: {searchResult.parents.father.name}</Typography>
                          <Typography>Address: {searchResult.address}</Typography>
                          <Typography>Phone No: {searchResult.phoneNo}</Typography>
                        </Paper>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="OP Number"
                        name="opNumber"
                        value={formData.intraOp.opNumber}
                        onChange={handleIntraOpChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel>Scheme</InputLabel>
                        <Select
                          name="scheme"
                          value={formData.intraOp.scheme}
                          onChange={handleIntraOpChange}
                          label="Scheme"
                        >
                          <MenuItem value="ADIP">ADIP</MenuItem>
                          <MenuItem value="SAST">SAST</MenuItem>
                          <MenuItem value="ESI">ESI</MenuItem>
                          <MenuItem value="Self">Self</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel>CI Company</InputLabel>
                        <Select
                          name="ciCompany"
                          value={formData.intraOp.ciCompany}
                          onChange={handleIntraOpChange}
                          label="CI Company"
                        >
                          <MenuItem value="Cochlear">Cochlear</MenuItem>
                          <MenuItem value="Med-El">Med-El</MenuItem>
                          <MenuItem value="Advanced Bionic">Advanced Bionic</MenuItem>
                          <MenuItem value="Digisonic">Digisonic</MenuItem>
                          <MenuItem value="AB">AB</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel>Side of Implant</InputLabel>
                        <Select
                          name="sideOfImplant"
                          value={formData.intraOp.sideOfImplant}
                          onChange={handleIntraOpChange}
                          label="Side of Implant"
                        >
                          <MenuItem value="Right">Right</MenuItem>
                          <MenuItem value="Left">Left</MenuItem>
                          <MenuItem value="Both">Both</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Model of Implant"
                        name="modelOfImplant"
                        value={formData.intraOp.modelOfImplant}
                        onChange={handleIntraOpChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Speech Processor Model"
                        name="speechProcessorModel"
                        value={formData.intraOp.speechProcessorModel}
                        onChange={handleIntraOpChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Surgery Date"
                        type="date"
                        name="surgeryDate"
                        value={formData.intraOp.surgeryDate}
                        onChange={handleIntraOpChange}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Surgeon Name"
                        name="surgeonName"
                        value={formData.intraOp.surgeonName}
                        onChange={handleIntraOpChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Surgery Center"
                        name="surgeryCenter"
                        value={formData.intraOp.surgeryCenter}
                        onChange={handleIntraOpChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel>Surgery Type</InputLabel>
                        <Select
                          name="surgeryType"
                          value={formData.intraOp.surgeryType}
                          onChange={handleIntraOpChange}
                          label="Surgery Type"
                        >
                          <MenuItem value="Mastoidectomy posterior tympanotomy">
                            Mastoidectomy posterior tympanotomy
                          </MenuItem>
                          <MenuItem value="Veria/transcranial approach">Veria/transcranial approach</MenuItem>
                          <MenuItem value="Suprameatal approach">Suprameatal approach</MenuItem>
                          <MenuItem value="Minimal incision approach">Minimal incision approach</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" sx={{ mt: 2, fontWeight: 'medium' }}>
                        Intra-Op Test Findings
                      </Typography>
                      <Divider sx={{ my: 1 }} />
                    </Grid>
                    <Grid container spacing={2} sx={{ pl: 2 }}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                          Box Test
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel>Status</InputLabel>
                          <Select
                            value={formData.intraOp.intraOpTest.boxTest.status}
                            onChange={(e) => handleTestChange('boxTest', 'status', e.target.value)}
                            label="Status"
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Normal">Normal</MenuItem>
                            <MenuItem value="Defective">Defective</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {formData.intraOp.intraOpTest.boxTest.status && (
                        <>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="No of Electrodes"
                              value={formData.intraOp.intraOpTest.boxTest.noOfElectrodes}
                              onChange={(e) => handleTestChange('boxTest', 'noOfElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="Specify Electrodes"
                              value={formData.intraOp.intraOpTest.boxTest.specifyElectrodes}
                              onChange={(e) => handleTestChange('boxTest', 'specifyElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                        </>
                      )}
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                          Impedance
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Impedance"
                          value={formData.intraOp.intraOpTest.impedance}
                          onChange={(e) => handleTestChange('impedance', 'impedance', e.target.value)}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="C-Arm Results"
                          value={formData.intraOp.intraOpTest.cArmResults}
                          onChange={(e) => handleTestChange('cArmResults', 'cArmResults', e.target.value)}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="ART"
                          value={formData.intraOp.intraOpTest.art}
                          onChange={(e) => handleTestChange('art', 'art', e.target.value)}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="NRT"
                          value={formData.intraOp.intraOpTest.nrt}
                          onChange={(e) => handleTestChange('nrt', 'nrt', e.target.value)}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                          Cochlear
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel>Status</InputLabel>
                          <Select
                            value={formData.intraOp.intraOpTest.cochlear.status}
                            onChange={(e) => handleTestChange('cochlear', 'status', e.target.value)}
                            label="Status"
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Ok">Ok</MenuItem>
                            <MenuItem value="Short">Short</MenuItem>
                            <MenuItem value="Open">Open</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {formData.intraOp.intraOpTest.cochlear.status && (
                        <>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="No of Electrodes"
                              value={formData.intraOp.intraOpTest.cochlear.noOfElectrodes}
                              onChange={(e) => handleTestChange('cochlear', 'noOfElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="Specify Electrodes"
                              value={formData.intraOp.intraOpTest.cochlear.specifyElectrodes}
                              onChange={(e) => handleTestChange('cochlear', 'specifyElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                        </>
                      )}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Impedance & NRT Report"
                          type="file"
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => handleFileChange('intraOp', 'impedanceNRT', e.target.files[0])}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                          Med-El
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel>Status</InputLabel>
                          <Select
                            value={formData.intraOp.intraOpTest.medEl.status}
                            onChange={(e) => handleTestChange('medEl', 'status', e.target.value)}
                            label="Status"
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Ok">Ok</MenuItem>
                            <MenuItem value="Short">Short</MenuItem>
                            <MenuItem value="Open">Open</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {formData.intraOp.intraOpTest.medEl.status && (
                        <>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="No of Electrodes"
                              value={formData.intraOp.intraOpTest.medEl.noOfElectrodes}
                              onChange={(e) => handleTestChange('medEl', 'noOfElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="Specify Electrodes"
                              value={formData.intraOp.intraOpTest.medEl.specifyElectrodes}
                              onChange={(e) => handleTestChange('medEl', 'specifyElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                        </>
                      )}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="IFT & ART Report"
                          type="file"
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => handleFileChange('intraOp', 'iftART', e.target.files[0])}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                          Digisonic
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel>Status</InputLabel>
                          <Select
                            value={formData.intraOp.intraOpTest.digisonic.status}
                            onChange={(e) => handleTestChange('digisonic', 'status', e.target.value)}
                            label="Status"
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Ok">Ok</MenuItem>
                            <MenuItem value="Short">Short</MenuItem>
                            <MenuItem value="Open">Open</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {formData.intraOp.intraOpTest.digisonic.status && (
                        <>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="No of Electrodes"
                              value={formData.intraOp.intraOpTest.digisonic.noOfElectrodes}
                              onChange={(e) => handleTestChange('digisonic', 'noOfElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="Specify Electrodes"
                              value={formData.intraOp.intraOpTest.digisonic.specifyElectrodes}
                              onChange={(e) => handleTestChange('digisonic', 'specifyElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                        </>
                      )}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Impedance Measure Report"
                          type="file"
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => handleFileChange('intraOp', 'impedanceMeasure', e.target.files[0])}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: '#555' }}>
                          AB
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel>Status</InputLabel>
                          <Select
                            value={formData.intraOp.intraOpTest.ab.status}
                            onChange={(e) => handleTestChange('ab', 'status', e.target.value)}
                            label="Status"
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Ok">Ok</MenuItem>
                            <MenuItem value="Short">Short</MenuItem>
                            <MenuItem value="Open">Open</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {formData.intraOp.intraOpTest.ab.status && (
                        <>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="No of Electrodes"
                              value={formData.intraOp.intraOpTest.ab.noOfElectrodes}
                              onChange={(e) => handleTestChange('ab', 'noOfElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="Specify Electrodes"
                              value={formData.intraOp.intraOpTest.ab.specifyElectrodes}
                              onChange={(e) => handleTestChange('ab', 'specifyElectrodes', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                        </>
                      )}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Intra-Op Findings Report"
                          type="file"
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => handleFileChange('intraOp', 'intraOpFindings', e.target.files[0])}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Electrodes Inside Cochlea"
                          value={formData.intraOp.intraOpTest.electrodesInside}
                          onChange={(e) => handleTestChange('electrodesInside', 'electrodesInside', e.target.value)}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Electrodes Outside Cochlea"
                          value={formData.intraOp.intraOpTest.electrodesOutside}
                          onChange={(e) => handleTestChange('electrodesOutside', 'electrodesOutside', e.target.value)}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Electrode Numbers"
                          value={formData.intraOp.intraOpTest.electrodeNumbers}
                          onChange={(e) => handleTestChange('electrodeNumbers', 'electrodeNumbers', e.target.value)}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Advanced Measure"
                        name="advancedMeasure"
                        value={formData.intraOp.advancedMeasure}
                        onChange={handleIntraOpChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Measurement Report"
                        name="measurementReport"
                        value={formData.intraOp.measurementReport}
                        onChange={handleIntraOpChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Switch-On Card */}
            <Grid item>
              <Card elevation={3} sx={{ borderRadius: 2 }}>
                <CardContent>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                    Switch-On Details
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="OP Enter"
                        name="opEnter"
                        value={formData.switchOn.opEnter}
                        onChange={handleSwitchOnChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Switch-On Center"
                        name="switchOnCenter"
                        value={formData.switchOn.switchOnCenter}
                        onChange={handleSwitchOnChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Date of Switch-On"
                        type="date"
                        name="dateOfSwitchOn"
                        value={formData.switchOn.dateOfSwitchOn}
                        onChange={handleSwitchOnChange}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Name of Surgeon"
                        name="surgeonName"
                        value={formData.switchOn.surgeonName}
                        onChange={handleSwitchOnChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Surgery Center"
                        name="surgeryCenter"
                        value={formData.switchOn.surgeryCenter}
                        onChange={handleSwitchOnChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Name of Audiologist"
                        name="audiologistName"
                        value={formData.switchOn.audiologistName}
                        onChange={handleSwitchOnChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel>Referral Letter Received</InputLabel>
                        <Select
                          name="referralLetter"
                          value={formData.switchOn.referralLetter}
                          onChange={handleSwitchOnChange}
                          label="Referral Letter Received"
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="NA">NA</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Model of Implant with S.No"
                        name="modelOfImplantWithSNo"
                        value={formData.switchOn.modelOfImplantWithSNo}
                        onChange={handleSwitchOnChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Model of Speech Processor with S.No"
                        name="modelOfSpeechProcessorWithSNo"
                        value={formData.switchOn.modelOfSpeechProcessorWithSNo}
                        onChange={handleSwitchOnChange}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel>Ear Implanted</InputLabel>
                        <Select
                          name="earImplanted"
                          value={formData.switchOn.earImplanted}
                          onChange={handleSwitchOnChange}
                          label="Ear Implanted"
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="Right">Right</MenuItem>
                          <MenuItem value="Left">Left</MenuItem>
                          <MenuItem value="Both">Both</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" sx={{ mt: 2, fontWeight: 'medium' }}>
                        Mapping
                      </Typography>
                      <Divider sx={{ my: 1 }} />
                    </Grid>
                    <Grid container spacing={2} sx={{ pl: 2 }}>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel>Mapping Type</InputLabel>
                          <Select
                            value={formData.switchOn.mapping.type}
                            onChange={(e) => handleNestedChange('switchOn', 'mapping', 'type', e.target.value)}
                            label="Mapping Type"
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Subjective">Subjective</MenuItem>
                            <MenuItem value="Objective">Objective</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {formData.switchOn.mapping.type === 'Objective' && (
                        <>
                          <Grid item xs={12} sm={2}>
                            <FormControl fullWidth variant="outlined" size="small">
                              <InputLabel>NRT</InputLabel>
                              <Select
                                value={formData.switchOn.mapping.nrt ? 'Yes' : 'No'}
                                onChange={(e) =>
                                  handleNestedChange('switchOn', 'mapping', 'nrt', e.target.value === 'Yes')
                                }
                                label="NRT"
                              >
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <FormControl fullWidth variant="outlined" size="small">
                              <InputLabel>ESRT</InputLabel>
                              <Select
                                value={formData.switchOn.mapping.esrt ? 'Yes' : 'No'}
                                onChange={(e) =>
                                  handleNestedChange('switchOn', 'mapping', 'esrt', e.target.value === 'Yes')
                                }
                                label="ESRT"
                              >
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <FormControl fullWidth variant="outlined" size="small">
                              <InputLabel>ECAP</InputLabel>
                              <Select
                                value={formData.switchOn.mapping.ecap ? 'Yes' : 'No'}
                                onChange={(e) =>
                                  handleNestedChange('switchOn', 'mapping', 'ecap', e.target.value === 'Yes')
                                }
                                label="ECAP"
                              >
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" sx={{ mt: 2, fontWeight: 'medium' }}>
                        Documents to be Uploaded
                      </Typography>
                      <Divider sx={{ my: 1 }} />
                    </Grid>
                    <Grid container spacing={2} sx={{ pl: 2 }}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Kit Counselling"
                          type="file"
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => handleFileChange('switchOn', 'kitCounselling', e.target.files[0])}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Discharge Summary"
                          type="file"
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => handleFileChange('switchOn', 'dischargeSummary', e.target.files[0])}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Post-Op X-Ray Report"
                          type="file"
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => handleFileChange('switchOn', 'postOpXray', e.target.files[0])}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Others"
                          type="file"
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => handleFileChange('switchOn', 'others', e.target.files[0])}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Switch-On Remarks"
                        name="remarks"
                        value={formData.switchOn.remarks}
                        onChange={handleSwitchOnChange}
                        multiline
                        rows={3}
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" sx={{ mt: 2, fontWeight: 'medium' }}>
                        Tentative Mapping Appointment Dates
                      </Typography>
                      <Divider sx={{ my: 1 }} />
                    </Grid>
                    <Grid container spacing={2} sx={{ pl: 2 }}>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel>Select Appointment</InputLabel>
                          <Select
                            value={formData.switchOn.selectedAppointment}
                            onChange={(e) => handleAppointmentChange(e.target.value)}
                            label="Select Appointment"
                          >
                            <MenuItem value="">Select</MenuItem>
                            {appointmentOptions.map((option, index) => (
                              <MenuItem key={index} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      {formData.switchOn.selectedAppointment && (
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Edit Appointment Date"
                            value={formData.switchOn.selectedAppointment}
                            onChange={(e) =>
                              handleAppointmentEdit(
                                formData.switchOn.mappingAppointments.indexOf(
                                  formData.switchOn.selectedAppointment
                                ),
                                e.target.value
                              )
                            }
                            variant="outlined"
                            size="small"
                          />
                        </Grid>
                      )}
                      {formData.switchOn.mappingAppointments.map((appointment, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                          <TextField
                            fullWidth
                            label={`Appointment ${index + 1}`}
                            value={appointment}
                            InputProps={{ readOnly: true }}
                            variant="outlined"
                            size="small"
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
   {/* Password Modal */}
      <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
        {/* Save Button */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{ mt: 2, px: 4, py: 1.5, borderRadius: 2, float: 'right' }}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Cochlear;